import React, { useState } from "react";
import { Modal, Button, Input, Form, Rate, message } from "antd";
import "./audienceFeedback.css";
import { useNavigate, useParams } from "react-router-dom";
import { submitFeedback } from "../../services/event/feedback-event";

const AudienceFeedback: React.FC = () => {
  const [isModalVisible, setIsModalVisible] = useState(true);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { eventId } = useParams();

  const handleCancel = () => {
    setIsModalVisible(false);
    navigate(`/login/attendee/${eventId}`);
    form.resetFields();
  };

  const handleSubmit = async (values: any) => {
    const feedbackData = {
      eventId: Number(eventId),
      audioVideoQuality: values.audioVideoQuality,
      easeOfUse: values.easeOfUse,
      contentRelevance: values.contentRelevance,
      presenterEffectiveness: values.presenterEffectiveness,
      additionalComments: values.feedback,
      userEmail: values.email,
      ratingsCount: values.ratingsCount,
    };

    try {
      const response = await submitFeedback(feedbackData);
      if (response.status === 201 ) {
        message.success("Feedback Submitted Successfully");
        form.resetFields();
        setIsModalVisible(false);
        navigate(`/login/attendee/${eventId}`);
      } else {
        message.error(`Error: ${response.data}`);
      }
    } catch (error) {
      message.error("Something went wrong while submitting feedback.");
    }
  };

  return (
    <div className="feedback-container">
      <Modal
        title="Audience Feedback"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Please input your email!" },
              { type: "email", message: "Please enter a valid email!" },
            ]}
          >
            <Input placeholder="Enter your email" />
          </Form.Item>
          <Form.Item
            label="Feedback"
            name="feedback"
            rules={[{ required: true, message: "Please provide feedback!" }]}
          >
            <Input.TextArea placeholder="Enter your feedback" rows={4} />
          </Form.Item>

          <div className="rating-section">
            <Form.Item
              label="Audio/Video Quality"
              name="audioVideoQuality"
              rules={[
                {
                  required: true,
                  message: "Please rate the audio/video quality!",
                },
              ]}
            >
              <Rate />
            </Form.Item>

            <Form.Item
              label="Ease of Use"
              name="easeOfUse"
              rules={[
                { required: true, message: "Please rate the ease of use!" },
              ]}
            >
              <Rate />
            </Form.Item>

            <Form.Item
              label="Content Relevance"
              name="contentRelevance"
              rules={[
                {
                  required: true,
                  message: "Please rate the content relevance!",
                },
              ]}
            >
              <Rate />
            </Form.Item>
            <Form.Item
              label="Presenter Effectiveness"
              name="presenterEffectiveness"
              rules={[
                {
                  required: true,
                  message: "Please rate the presenter's effectiveness!",
                },
              ]}
            >
              <Rate />
            </Form.Item>
          </div>
          <Form.Item className="feedback-buttons">
            <Button onClick={handleCancel} className="btn-cancel-wrapper">Cancel</Button>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default AudienceFeedback;
